import { render } from "./ChartTGE.vue?vue&type=template&id=1611d174&scoped=true"
import script from "./ChartTGE.vue?vue&type=script&lang=js"
export * from "./ChartTGE.vue?vue&type=script&lang=js"

import "./ChartTGE.vue?vue&type=style&index=0&id=1611d174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1611d174"]])

export default __exports__